import { MigrationSpec } from "../migration.models"

/**
 * Template for a new migration: copy this file, change the filters, drop it in `index.ts`.
 * Nothing else — no backend change, as long as `type` names an existing api-v2 OneTimesType.
 */
const aiProfileRoles: MigrationSpec = {
  type: "MIGRATE_AI_PROFILE_ROLES",
  collection: "AiProfile",
  risk: "INDEX",
  title: {
    en: "AI profiles → one per (customer, role)",
    tr: "AI profilleri → (müşteri, rol) başına bir kayıt"
  },
  description: {
    en:
      "Drops the pre-roles unique index on `customer`, backfills `role: SERVICE` and " +
      "`lastSelectedAt` (from `updatedAt`) on every profile that has none, then builds the " +
      "unique (customer, role) index.",
    tr:
      "AiProfile.customer üzerindeki rol öncesi unique indeksi düşürür, rolü olmayan her " +
      "profile `role: SERVICE` ve `lastSelectedAt` (`updatedAt`'ten) yazar, ardından unique " +
      "(customer, role) indeksini kurar."
  },
  affectedFilter: { $or: [{ role: { $exists: false } }, { role: null }] },
  sampleFields: ["customer", "role", "lastSelectedAt", "updatedAt"],
  indexes: {
    mustDrop: [{ keys: { customer: 1 }, unique: true }],
    mustExist: [{ keys: { customer: 1, role: 1 }, unique: true }]
  },
  preview: (doc) => ({
    ...doc,
    role: "SERVICE",
    lastSelectedAt: doc.lastSelectedAt ?? doc.updatedAt ?? null
  }),
  notes: [
    {
      en:
        "Until this runs, no customer can own a second AI role — initAiRole surfaces " +
        "`ai_role_migration_required` instead of a raw E11000.",
      tr:
        "Bu çalışmadan hiçbir müşteri ikinci bir AI rolü açamaz — initAiRole ham E11000 yerine " +
        "`ai_role_migration_required` döndürür."
    },
    {
      en:
        "syncIndexes() drops indexes that are not declared in the schema. Check the collection " +
        "for hand-made indexes before running.",
      tr:
        "syncIndexes() şemada tanımlı olmayan indeksleri düşürür. Çalıştırmadan önce koleksiyonda " +
        "elle eklenmiş indeks var mı kontrol edin."
    }
  ]
}

export default aiProfileRoles
